/* eslint-disable */
module.exports = {
  close: 'Zatvoriť',
  dataIterator: {
    pageText: '{0}-{1} z {2}',
    noResultsText: 'Nenašli sa žiadne údaje',
    loadingText: 'Údaje sa nahrávajú ...',
  },
  dataTable: {
    itemsPerPageText: 'Záznamov na stránke:',
    ariaLabel: {
      sortDescending: ': Zoradené vzostupne. Klinutie odstráni zoradenie.',
      sortAscending: ': Zoradené zostupne. Klinutie zoradí vzostupne.',
      sortNone: ': Not sorted. Activate to sort ascending.',
    },
    sortBy: 'Sort by',
  },
  dataFooter: {
    itemsPerPageText: 'Záznamov na stránke:',
    itemsPerPageAll: 'Všetky',
    nextPage: 'Ďalšia stránka',
    prevPage: 'Predchádzajúca stránka',
    firstPage: 'Prvá stránka',
    lastPage: 'Posledná stránka',
  },
  datePicker: {
    itemsSelected: '{0} označených',
  },
  noDataText: 'Žiadne údaje',
  carousel: {
    prev: 'Späť',
    next: 'Ďalej',
  },
  calendar: {
    moreEvents: '{0} viac',
  },
  fileInput: {
    counter: '{0} súborov',
    counterSize: '{0} súborov ({1} celkom)',
  }
}